import { PauseCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "../hooks/use-auth";
import { subscriptionDaysLeft } from "../lib/subscription";

/** Shown to a user whose trainer paused their subscription (feed and chat only). */
export function PausedNotice() {
  const { user } = useAuth();
  if (!user) return null;
  const days = subscriptionDaysLeft(user);
  return (
    <div className="shrink-0 border-b border-border/20 bg-[#0b1f2a] px-4 py-2 text-sm">
      <div className="mx-auto flex max-w-3xl items-start gap-2">
        <PauseCircle className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
        <p className="text-muted-foreground">
          <span className="font-medium text-foreground">Pretplata ti je pauzirana.</span>{" "}
          Dani ti ne teku ({days} {days === 1 ? "dan" : "dana"} te čeka). Kad želiš nastaviti, javi se
          treneru u{" "}
          <Link to="/chat" className="font-medium text-primary underline-offset-2 hover:underline">
            chatu
          </Link>
          .
        </p>
      </div>
    </div>
  );
}
